import { Tooltip } from '@mantine/core'
import type { CSSProperties, ReactNode } from 'react'
import { pillTooltipProps } from './pillTooltip'

// Pill palette mirrors the mockup at `ui-designs/.../ChartPage.tsx:802` —
// soft tinted background + a same-hue border + bold same-hue text.
const PILL_STYLES: Record<'green' | 'yellow' | 'gray', CSSProperties> = {
  green: {
    background: 'rgba(34,197,94,0.1)',
    color: '#16a34a',
    border: '1px solid rgba(34,197,94,0.3)',
  },
  yellow: {
    background: 'rgba(232,98,74,0.1)',
    color: '#e8624a',
    border: '1px solid rgba(232,98,74,0.25)',
  },
  gray: {
    background: 'rgba(156,163,175,0.12)',
    color: '#6b7280',
    border: '1px solid rgba(156,163,175,0.3)',
  },
}

type StatusPillProps = {
  color: 'green' | 'yellow' | 'gray'
  /** Shown on hover over the whole pill. */
  tooltip: ReactNode
  multiline?: boolean
  children: ReactNode
}

/** Shared chart-header status pill (portal activity + identity verification). */
export function StatusPill({ color, tooltip, multiline, children }: StatusPillProps) {
  return (
    <Tooltip
      label={tooltip}
      {...pillTooltipProps}
      {...(multiline ? { multiline: true, w: 250 } : {})}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          padding: '2px 8px',
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 600,
          cursor: 'default',
          ...PILL_STYLES[color],
        }}
      >
        {children}
      </div>
    </Tooltip>
  )
}
